// extracted by mini-css-extract-plugin
export default {"verify_container":"verify_verify_container__oxFyD"};